var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-cms-past-chairmans"},[_c('staffs-editor',{attrs:{"title":"18屆會務名冊","id":"18_staffs"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }